import { useQuery } from "@tanstack/react-query";
import { BACKEND_URL } from "../config";
import axios from "axios";

type Hosting = {
    id: string;
    name: string;
    plesk_name: string;
    description: string;
    storage: string;
    email_redirects: number;
    email_accounts: number;
    ftp_users: number;
    traffic_included: boolean;
    num_databases: number;
    php: boolean;
    catchall_mail: boolean;
    backup_server: boolean;
    server_location: string;
    management_tool: string;
    contract_duration_months: number;
    cancellation_period_weeks: number;
    payment_interval_months: number;
    setup_price: number;
    setup_price_discounted: number | null;
    price: number;
    price_discounted: number | null;
};

const listHosting = (url: string) => {
    return axios.request({
        url: url,
        withCredentials: true,
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        method: "GET",
    });
};

export const useListHosting = () => {
    const url = `${BACKEND_URL}/api/v1/hosting-products`;

    return useQuery<{ data: Array<Hosting> }>({
        queryKey: [url],
        queryFn: async () => {
            const response = await listHosting(url);
            return response.data;
        },
    });
};
